import { render, staticRenderFns } from "./FlashcardModal.vue?vue&type=template&id=459c53da&scoped=true&"
import script from "./FlashcardModal.vue?vue&type=script&lang=js&"
export * from "./FlashcardModal.vue?vue&type=script&lang=js&"
import style0 from "./FlashcardModal.vue?vue&type=style&index=0&id=459c53da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459c53da",
  null
  
)

export default component.exports